import React, { useCallback, useState } from 'react'

import { useCitizenAIAssistant } from 'src/components/CitizenAIAssistant/CitizenAIAssistantContext'
import { Button, Input, T, VStack } from 'src/govwell-ui'
import { useSearchOrganizationsQuery } from 'src/pages/CitizenAIAssistantPage/use-search-organizations'

const CitizenTownSelector = () => {
  const context = useCitizenAIAssistant()
  const [searchQuery, setSearchQuery] = useState('')
  const { organizations, isLoading } = useSearchOrganizationsQuery(searchQuery)
  const setCurrentOrgContext = context?.setCurrentOrgContext

  const handleSelectTown = useCallback(
    (slug: string, displayName: string) => {
      if (setCurrentOrgContext) {
        setCurrentOrgContext({
          orgSlug: slug,
          orgDisplayName: displayName,
        })
        context?.startNewConversation()
      }
    },
    [setCurrentOrgContext, context]
  )

  return (
    <div className="mx-auto w-full max-w-md px-4 pb-4">
      <VStack gap={3} align="stretch">
        <T.BodySmall className="text-center text-neutral-500">
          Want answers specific to your organization (town, county, etc.)? Select your jurisdiction
          for details on local permits, fees, codes, and contacts.
        </T.BodySmall>
        <Input
          ariaLabel="Search for an organization"
          placeholder="Search for your organization..."
          value={searchQuery}
          onValueChange={setSearchQuery}
          width="100%"
        />
        {isLoading && (
          <T.BodySmall className="text-center text-neutral-500">Searching...</T.BodySmall>
        )}
        {!isLoading && organizations.length > 0 && (
          <div className="flex max-h-48 flex-col gap-2 overflow-y-auto">
            {organizations.map((org) => (
              <Button
                key={org.slug}
                variant="default"
                onClick={() => handleSelectTown(org.slug, org.displayName)}
                className="text-left"
              >
                <T.Body>
                  {org.displayName}
                  {org.state && <span className="ml-1 text-neutral-500">({org.state})</span>}
                </T.Body>
              </Button>
            ))}
          </div>
        )}
        {!isLoading && searchQuery && organizations.length === 0 && (
          <T.BodySmall className="text-center text-neutral-500">
            No organizations found matching &ldquo;{searchQuery}&rdquo;
          </T.BodySmall>
        )}
      </VStack>
    </div>
  )
}

export default React.memo(CitizenTownSelector)
